import { InlineWidgetConfig } from '@nykaa/nes-listing-shared/type';
import { CustomWidgetRendererProps } from 'components/WidgetRenderer/Loadable';
import { SHOPPING_BAG, SOURCE_PAGE } from 'constants/searchSuggestion';
import { platformNames } from 'shared/constants';
import { INDIA_ISO_CODE } from 'shared/constants/internationalShipping';
import { State } from 'store/types';

export const isValidObject = (item: object) => {
  if (typeof item === 'object' && !Array.isArray(item) && item !== null) {
    return true;
  }
  return false;
};

export const isValidArrayLength = (arr: any[]): boolean =>
  Array.isArray(arr) && !!arr.length;

export const isIndianRegion = (regionCountry: string = '') =>
  !!(regionCountry && !!(regionCountry === INDIA_ISO_CODE));

export const getDnPageTypeFromWidgetData = (dnWidgetData: any) => {
  let dnPageType = '';
  try {
    dnPageType = !(dnWidgetData.widgets.length > 0)
      ? ''
      : dnWidgetData.widgets[0]?.inventoryPageType;
  } catch (error) {
    dnPageType = '';
  }
  return dnPageType;
};

export const getApiParams = (
  state: State,
  ownProps: CustomWidgetRendererProps
) => {
  const {
    remainingInventoryIds = [],
    allWidgetsLength = 0,
    noImpressionImmediatePaginationCall = false,
    queryParamsObject = {},
  } = ownProps;
  const paginationParams = {
    isPaginationEnabled: !!state?.remoteConfig?.switches?.isPaginationEnabled,
    bufferSize:
      state?.remoteConfig?.configs?.dnPaginationConfig?.bufferSize || 3,
    pageLimit:
      state?.remoteConfig?.configs?.dnPaginationConfig?.pageLimit || 10,
    remainingInventoryIds,
    initialInventoryCount: allWidgetsLength,
    noImpressionImmediatePaginationCall,
  };
  const apiParams = {
    params: queryParamsObject,
    paginationParams,
  };
  return apiParams;
};

export const minInlineWidgetIndex = (
  positionMap: InlineWidgetConfig['positionMap']
) => {
  if (isValidObject(positionMap)) {
    let minIndex = Number.MAX_SAFE_INTEGER;
    Object.values(positionMap).map((index) => {
      if (minIndex > index) {
        minIndex = index;
      }
    });
    return minIndex;
  }
  return -1;
};

export const isValidString = (str: string): boolean =>
  typeof str === 'string' && !!str.length;
export const IS_MEN = __PLATFORM__ === platformNames.MEN;

export const getUpdatedPageType = (
  search: string,
  pageType?: string
): string => {
  const sourcePage = new URLSearchParams(search).get(SOURCE_PAGE) || '';
  if (pageType) {
    return pageType;
  } else if (sourcePage && sourcePage === SHOPPING_BAG) {
    return sourcePage;
  } else {
    return '';
  }
};
